import Image from 'next/image';

import { Grid, List, ListItem, Avatar, ListItemAvatar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { SectionHeader } from '@/src/components/molecules';
import { Section } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  grid: {
    maxWidth: '100%',
    background: theme.palette.primary.dark,
  },
  textWhite: {
    color: 'white',
  },
  checkBox: {
    background: 'transparent',
    borderRadius: 0,
  },
  title: {
    fontWeight: 'bold',
  },
  imageGrid: {
    margin: `${theme.spacing(6)} auto`,
    [theme.breakpoints.down('md')]: {
      maxWidth: 500,
      marginBottom: 0,
    },
  },
}));

const Features = props => {
  const { data, className, ...rest } = props;

  const classes = useStyles();

  return (
    <div className={className} {...rest}>
      <Grid container className={classes.grid} alignItems="center">
        <Grid
          item
          container
          xs={12}
          md={6}
          data-aos="fade-up"
          justifyContent="center"
          className={classes.imageGrid}>
          <Image src="/images/illustrations/careers/feature-2.svg" width={900} height={686} />
        </Grid>
        <Grid item container alignItems="center" xs={12} md={6}>
          <Section>
            <>
              <SectionHeader
                title="Nossos valores"
                subtitle="Acreditamos no potencial individual e na força de uma equipe determinada a superar qualquer desafio. Conheça nossos valores."
                align="left"
                data-aos="fade-up"
                titleProps={{
                  className: clsx(classes.textWhite, classes.title),
                }}
                subtitleProps={{
                  className: classes.textWhite,
                }}
              />
              <List>
                {data.map((item, index) => (
                  <ListItem disableGutters key={index.toString()} data-aos="fade-up">
                    <ListItemAvatar>
                      <Avatar
                        src="https://assets.maccarianagency.com/the-front/illustrations/check-icon-yellow.svg"
                        alt="Nossos valores"
                        className={classes.checkBox}
                      />
                    </ListItemAvatar>
                    <Typography variant="body1" color="textPrimary" className={classes.textWhite}>
                      {item}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </>
          </Section>
        </Grid>
      </Grid>
    </div>
  );
};

Features.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Features;
